import { updatePurposeLimitationsGuest, updatePurposeLimitationsMember, setSqCookie, setNiCCookie, checkIsSqCookieDeprecatedByLocation, } from '../../services/purposeLimitations';
import getPurposeLimitationsGuestState from '../selectors/getPurposeLimitationsGuestState';
import { PURPOSE_LIMITATIONS_ACTION_TYPES, } from '../constants';
import { store } from '..';
import { handleMemberResponseServerLimitations, handleGuestResponseServerLimitations, } from './utils';
const getPurposeLimitationsMemberAction = ({ accessToken, userId, userExperience, memberLocation, }) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_MEMBER_PENDING,
            });
            const responseLimitations = await handleMemberResponseServerLimitations({
                accessToken,
                userId,
                userExperience,
                memberLocation,
                noCache: false,
            });
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_MEMBER_SUCCESS,
                payload: responseLimitations,
            });
        }
        catch (error) {
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_MEMBER_FAIL,
                payload: error.message,
            });
        }
    };
};
const getPurposeLimitationsGuestAction = ({ userId, userExperience, guestLocation, }) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_GUEST_PENDING,
            });
            const storedPurposeLimitationsGuestState = getPurposeLimitationsGuestState(getState());
            const responseLimitations = await handleGuestResponseServerLimitations({
                userId,
                userExperience,
                guestLocation,
                storedPurposeLimitationsGuestState,
            });
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_GUEST_SUCCESS,
                payload: responseLimitations,
            });
        }
        catch (error) {
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.GET_PURPOSE_LIMITATIONS_GUEST_FAIL,
                payload: error.message,
            });
        }
    };
};
const getInitialConsentTimestamp = (currentInitialTimestamp, captureInitialConsent) => {
    if (!captureInitialConsent)
        return currentInitialTimestamp;
    return currentInitialTimestamp || Date.now();
};
const updatePurposeLimitationsMemberAction = (props) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_MEMBER_PENDING,
            });
            await updatePurposeLimitationsMember(props);
            const responseLimitations = await handleMemberResponseServerLimitations({
                accessToken: props.accessToken,
                userId: props.userId,
                userExperience: props.userExperience,
                memberLocation: props.memberLocation,
                noCache: true,
            });
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_MEMBER_SUCCESS,
                payload: responseLimitations,
            });
        }
        catch (error) {
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_MEMBER_FAIL,
                payload: error.message,
            });
        }
    };
};
const updatePurposeLimitationsGuestAction = (contextFrameToUpdate, captureInitialConsent, guestLocation) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_GUEST_PENDING,
            });
            const { userId, purposeLimitationsLevels, initialConsentTimestamp: purposeLimitationsInitialConsentTimestamp, } = getPurposeLimitationsGuestState(store.getState());
            const updatedPurposeLimitations = updatePurposeLimitationsGuest(contextFrameToUpdate);
            setNiCCookie(updatedPurposeLimitations);
            if (!checkIsSqCookieDeprecatedByLocation(guestLocation)) {
                setSqCookie(updatedPurposeLimitations);
            }
            const initialConsentTimestamp = getInitialConsentTimestamp(purposeLimitationsInitialConsentTimestamp, captureInitialConsent);
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_GUEST_SUCCESS,
                payload: {
                    purposeLimitations: updatedPurposeLimitations,
                    purposeLimitationsLevels,
                    initialConsentTimestamp,
                    userId,
                    lastUpdatedTimestamp: Date.now(),
                },
            });
        }
        catch (error) {
            return dispatch({
                type: PURPOSE_LIMITATIONS_ACTION_TYPES.UPDATE_PURPOSE_LIMITATIONS_GUEST_FAIL,
                payload: error.message,
            });
        }
    };
};
const resetPurposeLimitationsMemberAction = () => ({
    type: PURPOSE_LIMITATIONS_ACTION_TYPES.RESET_PURPOSE_LIMITATIONS_MEMBER,
});
const resetLimitationsErrorMemberAction = () => ({
    type: PURPOSE_LIMITATIONS_ACTION_TYPES.RESET_ERROR_PURPOSE_LIMITATIONS_MEMBER,
});
const resetLimitationsErrorGuestAction = () => ({
    type: PURPOSE_LIMITATIONS_ACTION_TYPES.RESET_ERROR_PURPOSE_LIMITATIONS_GUEST,
});
export { getPurposeLimitationsMemberAction, getPurposeLimitationsGuestAction, updatePurposeLimitationsMemberAction, updatePurposeLimitationsGuestAction, resetPurposeLimitationsMemberAction, resetLimitationsErrorMemberAction, resetLimitationsErrorGuestAction, };
